import React, { useContext, useEffect, useState } from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import { useHistory, useParams } from 'react-router-dom';
import { AppContext } from '../../../contexts/AppContext';
import DefaultCard from '../../../components/default/DefaultCard';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import useMonthlyClosureDetailService from '../../../app/services/hooks/useMonthlyClosureDetailService';
import { MonthlyClosureDetailDataForm, defaultMonthlyClosureDetailDataForm } from '../../../app/models/MonthlyClosureDetail';
import { formatDateToMonth } from '../../../helpers';
import { defaultMonthlyClosureDataForm, MonthlyClosureDataForm } from '../../../app/models/MonthlyClosure';
import MonthlyClosureDetailWorkerContainer from '../components/MonthlyClosureDetailWorkerContainer';


type RouterParams = {
    id: string;
};

const MonthlyClosureDetailEdit = () => {

    const history = useHistory();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { id } = useParams<RouterParams>();
    const [monthlyClosureDetail, setMonthlyClosureDetail] = useState<MonthlyClosureDetailDataForm>(defaultMonthlyClosureDetailDataForm);
    const [monthlyClosure, setMonthlyClosure] = useState<MonthlyClosureDataForm>(defaultMonthlyClosureDataForm);

    
    const { 
        editMonthlyClosureDetails,
        fetchingEditMonthlyClosuresDetail 
    } = useMonthlyClosureDetailService()

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: `Detalle de cierre mensual por sociedad ${monthlyClosureDetail?.society}`,
            url: `/monthly-closures-detail/${id}/edit`,
            isActive: true
        }
    ];
    
    
    useEffect(() => {
        editMonthlyClosureDetails(Number(id), {
            onSuccess: (response: ServiceResponse) => {
                setMonthlyClosureDetail(response.data.monthly_closure_detail);
                setMonthlyClosure(response.data.monthly_closure);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });
            }
        });
    }, []);


    
    return (
        <>
            <Breadcrumbs pageSection="Detalle cierre mensual" breadcrumbs={breadcrumbs} />

            <div className="row">
                <div className="col-md-6">
                    <DefaultCard>

                        {!fetchingEditMonthlyClosuresDetail ? (
                            <>
                                <div className="h3 mt-0 mb-2 card-title">Sociedad: {monthlyClosureDetail?.society}</div>
                                <div className="h3 mt-0 mb-2 card-title">Mes: {formatDateToMonth(monthlyClosure?.closing_date)}</div>
                            </>
                        ) : (
                            // )
                            <LazyLoading height={300}/>
                        )}
                    </DefaultCard>
                </div>
            </div>
            {!fetchingEditMonthlyClosuresDetail ? (
                <>
                    <MonthlyClosureDetailWorkerContainer
                        monthlyClosureDetailId={parseInt(id)}
                    />
                </>
            ) : null}
          
            
        </>
    )
}

export default MonthlyClosureDetailEdit
